import _ from 'lodash';
import { countryMap } from 'shared/core/constants/geography';
import { getComplianceConfig } from 'shared/core/helpers/compliance';
import { yup } from 'shared/core/yup';
import errors from 'shared/core/fieldValidationErrorMessages';
function medicalCardState(_ref) {
  var $state = _ref.state,
    country = _ref.country;
  if (country === 'Puerto Rico' || country === 'PR') {
    $state = 'PR';
  }
  var errorMessage = getComplianceConfig($state, "medCardReciprocity") ? errors.medicalCard.validState : errors.medicalCard.stateMatch;
  return {
    message: errorMessage,
    test: function test(value) {
      // DC allows you to have a med card from any state.
      // Jamaica, Saint Vincent and the Grenadines don't have state requirements
      if ($state === 'DC' || _.includes([countryMap.JM, countryMap.VC], country)) {
        return true;
      }
      if (!getComplianceConfig($state, "medCardReciprocity") && value !== $state) {
        return false;
      }
      if (getComplianceConfig($state, "medCardReciprocity") && getComplianceConfig($state, "limitedStateReciprocity") && !_.includes(getComplianceConfig($state, "medCardLimitedReciprocity"), value)) {
        return false;
      }
      return true;
    }
  };
}
function medicalCardPhoto($storeSettings, deliveryOption) {
  var requireMedCardPhotoForPickup = $storeSettings.requireMedCardPhotoForPickup,
    requireMedCardPhotoForDelivery = $storeSettings.requireMedCardPhotoForDelivery;
  var required = requireMedCardPhotoForPickup && !deliveryOption || requireMedCardPhotoForDelivery && deliveryOption;
  return {
    message: errors.medicalCard.photoMissing,
    test: function test(value) {
      if (required && _.isEmpty(value)) {
        return false;
      }
      return true;
    }
  };
}
export function medicalCard(isMedicalOrder, isKioskOrder, deliveryOption, $dispensary) {
  var removeMedicalCardFieldsAtCheckout = $dispensary.removeMedicalCardFieldsAtCheckout,
    location = $dispensary.location,
    storeSettings = $dispensary.storeSettings;
  if (!isMedicalOrder || isKioskOrder || removeMedicalCardFieldsAtCheckout) {
    return yup.mixed().notRequired();
  }
  return yup.object().shape({
    expirationDate: yup.string().beforeToday('MM/DD/YYYY', errors.medicalCard.expired).test('len', errors.medicalCard.expirationDateMissing, function (val) {
      return (val === null || val === void 0 ? void 0 : val.length) === 10;
    }).required(),
    number: yup.string().test('len', errors.medicalCard.numberRequired, function (val) {
      return (val === null || val === void 0 ? void 0 : val.length) > 4;
    }).max(500, errors.medicalCard.tooLong).required(errors.medicalCard.numberRequired),
    state: yup.string().nullable().test(medicalCardState(location)),
    photo: yup.string().nullable().test(medicalCardPhoto(storeSettings, deliveryOption))
  });
}
export default yup.object().when(['medicalOrder', 'isKioskOrder', 'deliveryOption', '$dispensary'], medicalCard);

/*
 * medicalCard: {
 *   expirationDate: '02/20/2023',
 *   number: '123456',
 *   state: 'OR',
 *   photo: '0128fd214525907f961d03563b625eb0'
 * }
 */